import { GameStorageManager, Inject, Singleton } from '@denishussar/html5-game-engine';

interface ISoundModel {
    musicOn: number;
    fxOn: number;
}

@Singleton
export class SoundModel {
    private static _gameStorage: GameStorageManager;
    private static _loadData: ISoundModel;

    private static musicOn = 1;
    private static fxOn = 1;
    private static soundOn = 1;

    private static soundLevel = 1;

    private static musicLevel = 0.2;
    private static fxLevel = 1;
    private static uiLevel = .4;

    constructor(@Inject private _$gameStorage: GameStorageManager) {
        SoundModel._gameStorage = this._$gameStorage;
        SoundModel._loadData = JSON.parse(SoundModel._gameStorage.loadData('sound'));

        if (SoundModel._loadData) {
            for (const o in SoundModel._loadData) {
                if (SoundModel[o]) {
                    SoundModel[o] = parseFloat(SoundModel._loadData[o]);
                }
            }

            SoundModel.musicLevel = .2;
            SoundModel.fxLevel = 1;
            SoundModel.uiLevel = .4;
            SoundModel.soundOn = 1;
        } else {
            SoundModel._loadData = {
                musicOn: SoundModel.musicOn,
                fxOn: SoundModel.soundOn,
            }
        }
    }

    public static musicON(value = true): void {
        SoundModel.musicOn = value ? 1 : 0;

        SoundModel._loadData.musicOn = SoundModel.musicOn;
        SoundModel._gameStorage.saveData('sound', JSON.stringify(SoundModel._loadData));
    }

    public static fxON(value = true): void {
        SoundModel.fxOn = value ? 1 : 0;

        SoundModel._loadData.fxOn = SoundModel.fxOn;
        SoundModel._gameStorage.saveData('sound', JSON.stringify(SoundModel._loadData));
    }

    public static soundON(value = true): void {
        this.soundOn = value ? 1 : 0;
    }

    public static get UI(): number {
        return SoundModel.soundLevel * SoundModel.uiLevel * SoundModel.fxOn * SoundModel.soundOn;
    }

    public static get music(): number {
        return SoundModel.soundLevel * SoundModel.musicLevel * SoundModel.musicOn * SoundModel.soundOn;
    }

    public static get fx(): number {
        return SoundModel.soundLevel * SoundModel.fxLevel * SoundModel.fxOn * SoundModel.soundOn;
    }
}
